import { ExceptionTypes } from "@/utils/constants";
import {
  Route,
  UserRoute,
  Invite,
  Org,
  Assessment,
  Scanning,
  Checklist,
  Subscription,
  Vendor,
} from "./routes";

export const CustomExceptionsUIText: Record<ExceptionTypes, string> = {
  [ExceptionTypes.InvalidEmail]: "app-api-error-invalid-email-provided-1",
  [ExceptionTypes.ChecklistRequestedFetchFailed]:
    "app-api-error-vender-checklist-fetch-failed-1",
  [ExceptionTypes.InvalidForecastDate]: "app-api-error-invalid-forecast-date-1",
  [ExceptionTypes.ChecklistItemForecastInvalidGroupId]:
    "app-api-error-invalid-group-id-1",
  [ExceptionTypes.OrgPlanNotEntitled]: "exc_org_plan_not_entitled",
  [ExceptionTypes.OidCookieNotPresent]: "app-api-error-session-invalid-1",
  [ExceptionTypes.InvalidSession]: "app-api-error-session-invalid-1",
  [ExceptionTypes.LoginException]: "app-api-error-auth-perm-2-1",
  [ExceptionTypes.ProfileUpdateFailed]: "app-api-error-profile-update-fail-1",
  [ExceptionTypes.excIdNotExistNotAccessible]:
    "app-api-error-id-not-exist-not-accessible-1",
  [ExceptionTypes.FileDoesNotExistsInS3Bucket]:
    "app-api-error-file-not-exist-in-s3-1",
  [ExceptionTypes.ReadFail]: "app-api-error-get-user-can-not-read-1",
  [ExceptionTypes.DeleteFail]: "app-api-error-delete-fail-1",
  [ExceptionTypes.UserPasswordChangeFail]:
    "app-api-user-password-change-fail-1",
  [ExceptionTypes.UserMFAEnableFail]: "app-api-user-mfa-enable-fail-1",
  [ExceptionTypes.UserMFAVerifyFail]: "app-api-user-mfa-verify-fail-1",

  //Invite
  [ExceptionTypes.DomainRestricted]: "app-api-invite-domain-restricted-error-1",
  [ExceptionTypes.OrgAccessRequestOwnDomainNotAllowed]:
    "app-api-invite-access-request-domain-not-allowed-error-1",
  [ExceptionTypes.OrgAccessRequestVerifiedDomainsNotAllowed]:
    "app-api-invite-request-verified-domain-not-allowed-error-1",
  [ExceptionTypes.InvalidParameters]: "app-api-invite-invalid-param-error-1",
  [ExceptionTypes.OrgToOrgTypeNotLockable]:
    "app-api-invite-org-type-not-lock-error-1",
  [ExceptionTypes.OrgAccessRequestError]:
    "app-api-invite-access-request-error-1",
  [ExceptionTypes.OrgAccessOfferOwnDomainsNotAllowed]:
    "app-api-invite-access-offer--domain-not-allowed-error-1",
  [ExceptionTypes.OrgAccessOfferVerifiedDomainsNotAllowed]:
    "app-api-invite-offer-veri-doamin-not-allowed-error-1",
  [ExceptionTypes.OrgAccessOfferUnauthorisedToOfferRole]:
    "app-api-invite-access-offer-role-error-1",

  //Org
  [ExceptionTypes.InvalidDomain]: "app-api-org-invalid-domain-error-1",
  [ExceptionTypes.InvalidTLD]: "app-api-org-invalid-tld-error-1",
  [ExceptionTypes.OrgSwitchPlanNotEntitled]:
    "app-api-org-switch-not-entitled-error-1",
  [ExceptionTypes.OrgSwitchFailed]: "app-api-org-switch-error-1",
  [ExceptionTypes.FileUploadToS3Failed]: "app-api-org-file-up-load-error-1",
  [ExceptionTypes.OrgToProfileImageUpdateFailed]:
    "app-api-org-profile-image-upload-error-1",
  [ExceptionTypes.OrgToProfileImageCreateFailed]:
    "app-api-org-profile-image-create-error-1",
  [ExceptionTypes.UserEmailAlreadyExists]:
    "app-api-org-email-already-exists-error-1",
  [ExceptionTypes.InvalidSalutationId]:
    "app-api-org-invalid-salutation-error-1",
  [ExceptionTypes.UserCreationFailed]: "app-api-org-create-error-1",
  [ExceptionTypes.UserDeactivated]: "app-api-org-user-deactivated-error-1",
  [ExceptionTypes.UserCannotDeleteThemselves]:
    "app-api-org-user-can-not-delete-themselves-error-1",
  [ExceptionTypes.InvalidRoleId]: "app-api-org-invalid-role-error-1",
  [ExceptionTypes.RoleMembersInvalid]: "app-api-org-rolo-member-error-1",
  [ExceptionTypes.RoleLastForCurrentUserInThisOrg]:
    "app-api-org-current-user-error-1",
  [ExceptionTypes.OrgAccessRequestInvalid]:
    "app-api-org-access-request-error-1",
  [ExceptionTypes.OrgAccessOfferInvalid]: "app-api-org-access-offer-error-1",
  [ExceptionTypes.OrgAccessOfferExpired]:
    "app-api-org-access-offer-expired-error-1",
  [ExceptionTypes.GetPermissionLevelValueFromCachedDataByKeyFail]:
    "app-api-org-access-offer-permission-level-error-1",
  [ExceptionTypes.OrgAccessRequestProcessUnauthorizedToProcess]:
    "app-api-org-contain-member-error-1",
  [ExceptionTypes.RoleContainsMembers]: "app-api-org-contain-member-error-1",
  [ExceptionTypes.OrgNameCodeAlreadyExists]:
    "app-api-org-name-code-exists-error-1",
  [ExceptionTypes.UpdateFail]: "app-api-org-update-error-1",
  [ExceptionTypes.RoleNameInvalid]: "app-api-org-name-ivalid-error-1",
  [ExceptionTypes.RoleNameAlreadyExists]:
    "app-api-org-name-ready-exists-error-1",
  [ExceptionTypes.RoleTypeInvalid]: "app-api-org-type-invalid-error-1",
  [ExceptionTypes.UserNotAssociatedWithCurrentOrg]:
    "app-api-org-not-associated-with-current-error-1",
  [ExceptionTypes.UserPasswordResetFailed]:
    "app-api-org-user-password-reset-error-1",
  [ExceptionTypes.OrgMemberAlreadyDeactivated]:
    "app-api-org-member-already-error-1",
  [ExceptionTypes.UserNotAnInternalMemberOfCurrentOrg]:
    "app-api-org-user-not-an-internal-error-1",
  [ExceptionTypes.OrgMemberLastInRole]:
    "app-api-org-member-last-in-role-error-1",
  [ExceptionTypes.UserCannotDeactivateThemselves]:
    "app-api-org-cannot-deactive-error-1",
  [ExceptionTypes.OrgMemberDeactivationFail]:
    "app-api-org-member-deactive-error-1",
  [ExceptionTypes.UserNotAnExternalMemberOfCurrentOrg]:
    "app-api-member-of-current-fail-1",
  [ExceptionTypes.UserHasNoRoleMembershipsInThisOrg]:
    "app-api-org-role-member-ship-error-1",
  [ExceptionTypes.UserIdInvalid]: "app-api-org-user-invalid-error-1",
  [ExceptionTypes.OrgMemberAlreadyArchived]:
    "app-api-org-member-archived-error-1",
  [ExceptionTypes.OrgMemberDeletionFail]: "app-api-org-member-delete-error-1",
  [ExceptionTypes.EmailDomainNotRegistered]:
    "app-api-org-email-not-register-error-1",
  [ExceptionTypes.OrgAlreadyExists]: "app-api-org-exists-error-1",
  [ExceptionTypes.OrgProfileImageNotProvided]:
    "app-api-org-profile-not-provide-error-1",
  [ExceptionTypes.InvalidOrgId]: "app-api-org-invalid-org-error-1",
  [ExceptionTypes.OrgFetchFailed]: "app-api-org-fetch-error-1",
  [ExceptionTypes.UserCannotRevokeOwnHomeOrgAccess]:
    "app-api-org-can-not-revoke-error-1",
  [ExceptionTypes.UserLastRoleMemberForOrg]: "app-api-org-last-role-error-1",
  [ExceptionTypes.OrgDomainRetrivalFailed]:
    "app-api-org-domain-retrival-error-1",
  [ExceptionTypes.SOARecordNotExist]: "app-api-org-record-not-exitst-error-1",
  [ExceptionTypes.InvalidParent]: "app-api-org-invald-parent-error-1",
  [ExceptionTypes.OrgDomainAlreadyExist]:
    "app-api-org-domain-ready-exist-error-1",
  [ExceptionTypes.OrgDomainAddFailed]: "app-api-org-domain-add-error-1",
  [ExceptionTypes.InvalidOrgDomainId]: "app-api-org-domain-invalid-error-1",
  [ExceptionTypes.OrgDomainVerifyEmailDomainMismatch]:
    "app-api-org-domain-verify-mismatch-error-1",
  [ExceptionTypes.OrgDomainAlreadyVerifiedEmail]:
    "app-api-org-domain-verify-error-1",
  [ExceptionTypes.ItemIsParent]: "app-api-org-item-is-parent-error-1",
  [ExceptionTypes.OrgDomainUnableToDeleteInUse]:
    "app-api-request-org-domain-unable-delete-error-1",
  [ExceptionTypes.OrgDomainRecordNotFound]:
    "app-api-request-org-domain-recor-not-found-error-1",
  [ExceptionTypes.OrgDomainUpdateFailed]:
    "app-api-request-org-domain-update-found-error-1",
  [ExceptionTypes.DomainRegistrarIdInvalid]:
    "app-api-request-org-domain-invalid-register-error-1",
  [ExceptionTypes.OrgDomainNameUnupdatable]:
    "app-api-request-org-domain-name-un-update-error-1",
  [ExceptionTypes.OrgDomainNotVerifiedEmail]:
    "app-api-request-org-domain-not-verified-email-error-1",
  [ExceptionTypes.UserCannotUndeleteThemselves]:
    "app-api-org-user-not-undelete-themselves-error-1",
  [ExceptionTypes.OrgMemberIsNotArchived]:
    "app-api-org-member-is-not-archived-error-1",
  [ExceptionTypes.OrgDomainIsNotVerified]:
    "app-api-org-member-is-not-verified-error-1",
  [ExceptionTypes.UserAuthWebauthnMissingReferer]:
    "app-api-user-auth-web-missing-referer-error-1",

  //Assessment
  [ExceptionTypes.ChecklistCreateFailed]:
    "app-api-assessment-check-list-create-error-1",
  [ExceptionTypes.ChecklistToStatusCreateFailed]:
    "app-api-assessment-check-list-status-create-error-1",
  [ExceptionTypes.ChecklistTemplateToItemMasterFetchFail]:
    "app-api-assessment-check-list-master-fetch-error-1",
  [ExceptionTypes.ChecklistToItemCreateFailed]:
    "app-api-assessment-check-list-item-create-error-1",
  [ExceptionTypes.ChecklistItemToCategoryCreateFailed]:
    "app-api-assessment-check-list-item-to-category-create-error-1",
  [ExceptionTypes.ChecklistToTemplateCreateFailed]:
    "app-api-assessment-to-template-error-1",
  [ExceptionTypes.ChecklistReadFail]:
    "app-api-assessment-check-list-read-error-1",
  [ExceptionTypes.CreateFail]: "app-exception-handler-create-fail-error-1",
  [ExceptionTypes.ChecklistInvalidId]:
    "app-api-assessment-check-list-invalid-error-1",
  [ExceptionTypes.ChecklistReportDataFetchFailed]:
    "app-api-assessment-checklist-report-fetch-error-1",
  [ExceptionTypes.ChecklistToItemMetricDetailFetchFailed]:
    "app-api-assessment-checklist-to-item-metric-report-fetch-error-1",
  [ExceptionTypes.ChecklistToItemMetricGradeDetailFetchFailed]:
    "app-api-assessment-checklist-to-item-metric-grade-fetch-error-1",
  [ExceptionTypes.ChecklistToItemCompletionMetricDetailsFetchFailed]:
    "app-api-assessment-complate-error-1",
  [ExceptionTypes.ChecklistItemGroupDetailFetchFailed]:
    "app-api-assessment-checklist-item-group-detail-error-1",
  [ExceptionTypes.ChecklistForecastInvalidId]:
    "app-api-assessment-checklist-group-error-1",
  [ExceptionTypes.ChecklistCategoriesFetchFailed]:
    "app-api-assessment-categories-error-1",
  [ExceptionTypes.ChecklistTemplateInvalidId]:
    "app-api-assessment-check-list-template-invalid-error-1",
  [ExceptionTypes.ChecklistTemplatePlanNotEntitled]:
    "app-api-assessment-template-not-entitled-error-1",
  [ExceptionTypes.ChecklistToItemRefreshAllowedOnlyForNotCompletedState]:
    "app-api-assessment-to-item-refresh-all-complate-error-1",
  [ExceptionTypes.ChecklistToItemInputValidationFailed]:
    "app-api-assessment-to-input-validation-error-1",
  [ExceptionTypes.ChecklistIdInvalidForTheCurrentOrg]:
    "app-api-assessment-invalid-for-current-org-error-1",
  [ExceptionTypes.ChecklistCategoryIdInvalidForTheCurrentOrg]:
    "app-api-assessment-invalid-for-current-error-1",
  [ExceptionTypes.CreateRequestOrgDomainAlreadyExists]:
    "app-api-update-request-org-domain-is-your-own-error-1",
  [ExceptionTypes.CreateRequestOrgDuplicateRecord]:
    "app-api-update-request-org-record-duplicate-error-1",
  [ExceptionTypes.InvalidRecordId]:
    "app-api-update-request-org-ivalid-record-error-1",
  [ExceptionTypes.RecordAlreadyExists]:
    "app-api-update-request-org-record-exits-error-1",
  [ExceptionTypes.NotAssociatedWithCurrentOrg]:
    "app-api-org-not-associated-error-1",
  [ExceptionTypes.OrgMemberIsLocked]: "app-api-org-member-is-locked-error-1",
  [ExceptionTypes.EmailDomainNotVerified]: "app-api-org-email-not-verified-1",
  [ExceptionTypes.ChecklistItemGroupInvalidId]:
    "app-api-checklist-item-group-invalid-error-1",
  [ExceptionTypes.InvalidGroupMainId]:
    "app-api-checklist-group-main-id-error-1",
  [ExceptionTypes.FileClamScanFailed]: "app-api-error-clam-scan-1",
  [ExceptionTypes.ChecklistItemGroupActionIsNotArchived]:
    "app-api-checklist-item-group-action-is-not-archived-error-1",
  [ExceptionTypes.ChecklistToItemIdIsExcluded]:
    "app-api-checklist-item-to-item-is-excluded-error-1",
  [ExceptionTypes.ChecklistTemplateNoItems]:
    "app-api-checklist-template-no-items-error-1",
  //checklist

  //scanning
  [ExceptionTypes.ScanReportRunScheduleInvalidIds]:
    "app-api-scanning-schedule-scan-invalid-id-error-1",
  [ExceptionTypes.ScanReportRunScheduleAlreadyExists]:
    "app-api-scanning-schedule-scan-already-exists-error-1",
  [ExceptionTypes.ScanReportRunScheduleDuplicateIds]:
    "app-api-scanning-schedule-scan-duplicate-id-error-1",
  [ExceptionTypes.ScanReportRunScheduleDoesNotExist]:
    "app-api-scanning-schedule-scan-do-not-exist-error-1",
  [ExceptionTypes.ScanReportRunScheduleUpdateWebservicesFail]:
    "app-api-scanning-schedule-scan-update-webservice-error-1",
  [ExceptionTypes.ScanReportRunScheduleUpdateFail]:
    "app-api-scanning-schedule-scan-update-fail-error-1",
  [ExceptionTypes.ChecklistToTemplateNoItems]:
    "app-api-checklist-template-no-item-error-1",
  [ExceptionTypes.ChecklistTemplateAlreadyExists]:
    "app-api-checklist-template-already-exist-error-1",
  [ExceptionTypes.ChecklistTemplateNotOwnedByCurrentOrg]:
    "app-api-assessment-delete-template-error-not-owned-1",
  [ExceptionTypes.ChecklistUpdateFailedWrongStatus]:
    "app-api-assessment-update-failed-wrong-status-error-1",
  [ExceptionTypes.ChecklistToItemPerTypeDuplicationFetchFail]:
    "app-api-assessment-check-list-item-per-type-duplication-error-1",
  [ExceptionTypes.ScansSummaryFail]: "app-api-scanning-summary-error-1",
  [ExceptionTypes.ScanGetReportCSVFail]:
    "app-api-scanning-get-scan-report-error-1",
  [ExceptionTypes.excChecklistRequestedUpdateFailed]:
    "app-api-exc-checklist-requested-update-failed-error-1",
  [ExceptionTypes.ChecklistRequestedEmailVerifyFailed]:
    "app-api-exc-checklist-requested-verification-failed-error-1",

  //sharing
  [ExceptionTypes.RequiredIncidents]:
    "app-api-checklist-incident-create-error-1",
  [ExceptionTypes.ChecklistToCategoryInfoUpsertFailed]:
    "app-api-checklist-to-category-info-upsert-failed-1",
  [ExceptionTypes.UserUnauthorized]: "app-api-user-unauthorized-error-1",
  [ExceptionTypes.SystemActionsReadError]:
    "app-api-error-system-actions-read-1",

  //vendor
  [ExceptionTypes.ChecklistRequestedCreateFailed]:
    "app-api-error-vender-checklist-requested-create-failed-1",
  [ExceptionTypes.ChecklistTemplateReadFail]:
    "app-api-error-vender-checklist-template-read-fail-1",
  [ExceptionTypes.ChecklistRequestedInvalidExpiryDate]:
    "app-api-error-vender-checklist-requested-invalid-expiry-date-1",
  [ExceptionTypes.ChecklistRequestedEmailGrantFailed]:
    "app-api-error-vender-checklist-requested-email-grant-failed-1",
  [ExceptionTypes.ChecklistRequestedEmailGrantNotWithinDates]:
    "app-api-error-vender-checklist-requested-email-grant-not-within-dates-1",

  [ExceptionTypes.MinimumRequiredOptionalInputsMissing]:
    "app-api-error-vender-checklist-requested-email-grant-failed-1",
  [ExceptionTypes.SystemActionsReadError]:
    "app-api-error-system-actions-read-1",
  [ExceptionTypes.ChecklistTemplateNoItems]:
    "app-api-error-vender-checklist-template-no-item-1",
  [ExceptionTypes.generic_exception]: "app-api-error-generic-exception-1",
  [ExceptionTypes.domainVerifyCannotUpdate]:
    "app-api-error-domain-un-verify-email-1",
};

export const GenericExceptionsUIText = {
  [Route.languages]: "app-api-error-get-languages-generic-error-1",
  [Route.uiText]: "app-api-error-get-ui-text-generic-error-1",
  [UserRoute.get]: "app-api-error-get-user-generic-error-1",
  [UserRoute.logout]: "app-api-error-log-out-user-generic-error-1",
  [UserRoute.passwrodReset]: "app-api-error-reset-password-generic-error-1",
  [UserRoute.passwrodResetCallback]:
    "app-api-error-reset-password-generic-error-1",
  [UserRoute.profileUpdate]: "app-api-error-profile-update-generic-error-1",
  [UserRoute.getUserProfile]: "app-api-error-user-profile-generic-error-1",
  [UserRoute.getUserProfileImage]:
    "app-api-error-user-profile-image-generic-error-1",

  [Invite.orgAccessRequest]: "app-api-invite-org-access-request-error-1",
  [Invite.orgAccessRequestProcess]:
    "app-api-invite-org-access-request-process-error-1",
  [Invite.orgAccessOfferProcess]:
    "app-api-invite-org-access-offer-process-error-1",
  [Invite.orgAccessOffer]: "app-api-invite-org-access-offer-error-1",

  [Org.domain]: "app-api-org-org-domain-error-1",
  [Org.getOrgsCurrent]: "app-api-org-get-current-org-error-1",
  [Org.deleteMembersOfRole]: "app-api-org-delete-member-error-1",
  [Org.deleteRole]: "app-api-org-delete-role-error-1",
  [Org.getOrgPermLevels]: "app-api-org-permlevel-error-1",
  [Org.putOrgProfile]: "app-api-org-profile-error-1",
  [Org.createRequestVerification]: "app-api-create-request-org-error-1",
  [Org.editRequestVerification]: "app-api-update-request-org-error-1",
  [Org.deleteOrgRequest]: "app-api-update-request-org-error-1",
  [Org.postOrgRole]: "app-api-org-post-role-error-1",
  [Org.resetPasswordOrgMember]: "app-api-org-reset-password-member-error-1",
  [Org.putMemberRoles]: "app-api-org-error-member-role-error-1",
  [Org.getAddableOrgMembers]: "app-api-org-getaddable-error-1",
  [Org.deactivateOrgMember]: "app-api-org-deactive-member-error-1",
  [Org.deleteOrgExternalMember]: "app-api-org-delete-externa-member-error-1",
  [Org.resetPasswordOrgExternalMember]:
    "app-api-org-reset-password-externa-error-1",
  [Org.postOrgMemberMfaEnable]: "app-api-org-member-enable-error-1",
  [Org.deleteOrgMember]: "app-api-org-member-error-1",
  [Org.getAccessGrants]: "app-api-org-get-access-grant-error-1",
  [Org.getAccessGrantedToCurrentOrg]: "app-api-org-get-access-grants-error-1",
  [Org.getAccessGrantedToOtherOrgs]: "app-api-org-access-granted-error-1",
  [Org.getExternalMembersOfOrg]: "app-api-org-get-external-member-error-1",
  [Org.getMembersOfOrg]: "app-api-org-get-member-of-org-error-1",
  [Org.getOrgAccessTypes]: "app-api-org-get-access-type-error-1",
  [Org.getOrgDomainsInvalid]: "app-api-org-get-domain-invalid-error-1",
  [Org.getOrgRoleTypes]: "app-api-org-get-org-role-type-error-1",
  [Org.getOrgRoles]: "app-api-org-get-org-role-error-1",
  [Org.getOrgRoleById]: "app-api-org-get-role-by-id-error-1",
  [Org.getMembersOfRole]: "app-api-org-member-role-error-1",
  [Org.orgDomainVerifyCheck]: "app-api-org-domain-verify-check-error-1",
  [Org.orgDomainVerifyInitiate]: "app-api-org-domain-verify-initiate-error-1",
  [Org.getOrgsSwitch]: "app-api-org-switch-error-1",
  [Org.orgToProfileImageSave]: "app-api-org-profile-image-save-error-1",
  [Org.getOrgProfile]: "app-api-org-get-org-profile-error-1",
  [Org.getOrg]: "app-api-org-get-org-error-1",
  [Org.leaveOrg]: "app-api-org-lave-org-error-1",
  [Org.switchOrg]: "app-api-org-switch-org-error-1",
  [Org.getDomains]: "app-api-org-get-domains-error-1",
  [Org.getDomain]: "app-api-get-domain-org-error-1",
  [Org.getOrgs]: "app-api-org-get-orgs-error-1",
  [Org.createMember]: "app-api-org-create-member-error-1",
  [Org.postOrgSetup]: "app-exception-handler-error-unknown-error",
  [Org.postGoalSetup]: "app-exception-handler-error-unknown-error",
  [Org.postDomainSetup]: "app-exception-handler-error-unknown-error",
  [Org.postBrandSetup]: "app-exception-handler-error-unknown-error",
  [Org.postServicesSetup]: "app-exception-handler-error-unknown-error",
  [Org.postMiscSetup]: "app-exception-handler-error-unknown-error",
  [Org.postTeamsSetup]: "app-exception-handler-error-unknown-error",
  [Org.postSiteSetup]: "app-exception-handler-error-unknown-error",
  [Checklist.getChecklistGroupAction]:
    "app-exception-handler-error-unknown-error",
  [Checklist.getChecklistGroupTemplateAction]:
    "app-exception-handler-error-unknown-error",
  [Org.getRoleByUserId]: "app-exception-handler-error-unknown-error",
  [Org.postOrgIncident]: "app-api-update-request-org-record-duplicate-error-1",
  [Org.putOrgIncidents]: "app-api-update-request-org-record-duplicate-error-1",
  [Subscription.getSessionPortal]: "app-exception-handler-error-unknown-error",
  [Org.orgDomainVerify]: "app-exception-handler-error-unknown-error",
  [Scanning.getScanReportScheduleWebServices]:
    "app-exception-handler-error-unknown-error",
  [Scanning.getScanReportScheduleDomains]:
    "app-exception-handler-error-unknown-error",
  [Scanning.getRefreshIssuesWebServiceScanning]:
    "app-exception-handler-error-unknown-error",
  [Scanning.getRefreshIssuesDomainScanning]:
    "app-exception-handler-error-unknown-error",
  [Scanning.getScanReportDiffWebService]:
    "app-api-scanning-get-scan-report-error-1",
  [Checklist.getChecklistGroupMetrics]:
    "app-exception-handler-error-unknown-error",
  [Org.postWebFacingSetup]: "app-exception-handler-error-unknown-error",
  [Checklist.getChecklistToItemMetric]:
    "app-exception-handler-error-unknown-error",
  [Checklist.removeStep]: "app-exception-handler-error-unknown-error",
  [Checklist.addStep]: "app-exception-handler-error-unknown-error",
  [Assessment.checklistAttachment]: "app-exception-handler-error-unknown-error",
  [Org.deleteOneOrgMemberExternalDelete]:
    "app-exception-handler-error-unknown-error",
  [Assessment.checkListFromMasterAll]:
    "app-api-assessment-check-list-from-master-all-genric-error-1",
  [Assessment.checkListIdMetricsCompletion]:
    "app-api-assessment-check-list-metrics-completion-genric-error-1",
  [Assessment.getDetailFromCheckListId]:
    "app-api-assessment-get-detail-genric-error-1",
  [Assessment.getInputComplianceTypes]:
    "app-api-assessment-complate-type-genric-error-1",
  [Assessment.getCategories]: "app-api-assessment-categoties-genric-error-1",
  [Assessment.getChecklists]:
    "app-api-assessment-get-assessment-check-list-error-1",
  [Assessment.checkListIdMetricsCountCompliance]:
    "app-api-assessment-get-check-list-metrics-compliance-error-1",
  [Assessment.getChecklistContributors]:
    "app-api-assessment-get-check-list-contributors-error-1",

  [Assessment.getUserUploadFile]: "app-api-assessment-get-upload-file-error-1",
  [Assessment.postChecklistTemplate]:
    "app-exception-handler-error-unknown-error",
  [Assessment.checklistRename]:
    "app-api-exc-checklist-requested-update-failed-error-1",
  [Assessment.getChecklistAll]:
    "app-api-exc-checklist-requested-update-failed-error-1",
  [Scanning.getScanReportWebServiceCSV]:
    "app-api-scanning-get-scan-report-web-services-error-1",
  [Scanning.getScanReportDomainCSV]:
    "app-api-scanning-get-scan-report-web-services-error-1",
  [Scanning.postScanReportScheduleDomains]:
    "app-api-scanning-schedule-scan-error-1",
  [Scanning.postScanReportRunDomain]: "app-api-scanning-report-run-error-1",
  [Scanning.postScanReportRunWebService]:
    "app-api-scanning-report-run-webservice-error-1",
  [Org.postOrgProfile]: "app-settings-org-profile-update-profile-error-1",
  // [Assessment.postChecklistTemplate]:
  //   "app-assess-assessment-modal-create-assessment-template-post-error",
  [Checklist.deleteChecklistTemplate]:
    "app-api-assessment-delete-template-error-1",
  [Checklist.createChecklistToItem]:
    "app-exception-handler-error-unknown-error",
  [Org.postOrgMemberVerify]: "app-exception-handler-error-unknown-error",
  [Checklist.getChecklistCSV]: "app-api-assessment-get-check-list-csv-error-1",
  [Checklist.getChecklistReportData]:
    "app-api-assessment-checklist-report-fetch-error-1",
  [Checklist.getChecklistForecasts]:
    "app-api-assessment-get-checklist-forecast-error-1",
  [Checklist.createChecklistForecast]:
    "app-api-assessment-create-checklist-forecast-error-1",
  [Checklist.getAssessmentItemsCSV]:
    "app-api-assessment-get-assessment-item-csv-error-1",
  [Vendor.getRequestedAssessment]:
    "app-api-error-vender-checklist-fetch-failed-1",
  [Vendor.postRequestedAssessment]:
    "app-api-error-vender-post-checklist-requested-failed-1",
  [Vendor.postRequestAssessmentAttachment]:
    "app-api-error-vender-post-attachment-failed-1",
  [Vendor.postChecklistRequestedStatus]:
    "app-api-error-vender-post-checklist-requested-status-failed-1",
  [Vendor.putRequestedAssessment]:
    "app-vendor-assessment-delete-assessment-failed-1",
  [Vendor.putChecklistRequestedTemplate]:
    "app-assessment-vendor-delete-templates-failed-1",
};
